// ============================================
// FILE: src/components/ProtectedRoute.jsx
// ============================================
import React from 'react';
import { Navigate } from 'react-router-dom';
import useAuthStore from '../store/authStore';

const ProtectedRoute = ({ children, userType }) => {
  const { token, userType: currentUserType } = useAuthStore();

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  if (userType && currentUserType !== userType) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;